/**
 * © 2025 Little Shilling, Inc.
 * Shon Little
 * Created: 2025-07-24
 */

// Add local dependencies.
import EmailVerificationPending from './EmailVerificationPending';

export default EmailVerificationPending;
